<template>
  <div id="header-notifications" class="web-component">
    <app-icon-with-action @click="toggleShowNotifications" :hoverEffect="false" :title="$t('Notifications')">
      <i :class="['fal', `fa-envelope${isShownNotifications ? '-open' : ''}`]"></i>
      <span class="notifications-count" v-if="newNotificationCount"> {{ newNotificationCount }}</span>
    </app-icon-with-action>

    <div class="body-cover" @click.self="closeNotifications" v-show="isShownNotifications"></div>
    <transition name="slide">
      <notifications-window
        @read-new-notifications="readNewNotifications"
        @close="closeNotifications"
        v-if="isShownNotifications"/>
    </transition>
  </div>
</template>

<script>
import NotificationsWindow from '@/components/notificationsNew/NotificationsWindow'
import BaseComponent from '@/components/commentsNew/BaseComponent'
import AppIconWithAction from '../htmlHelpers/AppIconWithAction'

export default {
  name: 'Notifications',
  extends: BaseComponent,
  components: {
    AppIconWithAction,
    NotificationsWindow
  },
  data: function () {
    return {
      isShownNotifications: false,
      notifications: [],
      newNotificationCount: 0
    }
  },
  methods: {
    toggleShowNotifications () {
      this.isShownNotifications = !this.isShownNotifications
    },
    closeNotifications () {
      this.isShownNotifications = false
    },
    getNewNotificationsCount () {
      this.$http.get('new-notification-count')
        .then(response => {
          this.newNotificationCount = response.data.counts
        })
    },
    readNewNotifications () {
      this.newNotificationCount = 0
    }
  },
  mounted () {
    this.getNewNotificationsCount()
  }
}
</script>

<style scoped lang="scss">
#header-notifications {
  color: #646464;
  &:hover {
    color: var(--scheme-top-nav-txt);
  }

  .icon-with-action {
    padding: .5rem .375rem;
    font-size: 16px /*1rem*/;
    display: flex;
    align-items: center;
  }

  .body-cover {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1030;
    background-color: rgba(0, 0, 0, 0.3);
  }

  .slide-enter-active,
  .slide-leave-active {
    transform: translateX(0);
    transition: transform 0.5s ease-in-out;
  }

  .slide-enter,
  .slide-leave-to,
  .slide-leave-active {
    transform: translateX(480px);
  }

  .notifications-count {
    padding-left: .125rem;
    margin-bottom: .25rem;
  }
}
</style>
